import React, { useState, FC } from 'react';
import { Formik, Form, Field } from 'formik';
import * as yup from 'yup';
import { Auth } from '@aws-amplify/auth';
import { Alert, Heading, FormControl, FormLabel, FormErrorMessage, Input, AlertIcon, Button } from '@chakra-ui/react';
import { passwordRegExp } from '../../libs/utils';

type NewPasswordFormProps = {
  user: {
    username: string;
    password: string;
  };
  // TODO:
  // eslint-disable-next-line no-unused-vars
  callback(err: string | null, password?: string): void;
};

const NewPasswordForm: FC<NewPasswordFormProps> = ({ callback, user }) => {
  const [error, setError] = useState('');

  const errorMessage = error.length > 0 && (
    <Alert status='error'>
      <AlertIcon />
      {error}
    </Alert>
  );
  async function newPassword(evt: any) {
    const { password } = evt;
    setError('');

    try {
      await Auth.completeNewPassword(user, password, []);

      callback(null);
    } catch (err) {
      console.error({ action: 'newPassword', error: err });
      // TODO: define error in ts
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      setError(err.message);
    }
  }

  const newPasswordSchema = yup.object({
    password: yup
      .string()
      .matches(passwordRegExp, {
        message: (cur) => {
          const fails: string[] = [];
          if (!cur.value.match(/[a-z]/)) {
            fails.push('lowercase');
          }
          if (!cur.value.match(/[A-Z]/)) {
            fails.push('uppercase');
          }
          if (!cur.value.match(/[0-9]/)) {
            fails.push('number');
          }
          if (!cur.value.match(/[!@#$%^&*\-_.]/)) {
            fails.push('special character');
          }
          if (cur.value.match(/^\s/)) {
            fails.push('no spaces at the start or end');
          }

          return `Password must include ${fails.join(', ')}`;
        }
      })
      .min(8, 'Minimum length is 8 characters')
      .required('New password is required'),
    passwordConfirm: yup
      .string()
      .oneOf([yup.ref('password')], 'Passwords must match')
      .required('Confirm password is required')
  });

  return (
    <>
      <Heading as='h3'>Password change required</Heading>
      <Formik
        validationSchema={newPasswordSchema}
        // TODO:
        // eslint-disable-next-line react/jsx-no-bind
        onSubmit={newPassword}
        initialValues={{ password: '', passwordConfirm: '' }}
      >
        {({ isSubmitting, handleSubmit, errors }) => (
          <Form onSubmit={handleSubmit}>
            {errorMessage}

            <Field name='password'>
              {/* // TODO: edit ts to not complain about this
              // TODO: define error in ts
               eslint-disable-next-line @typescript-eslint/ban-ts-comment
               @ts-ignore */}
              {({ field, form }) => (
                <FormControl mb='8' isInvalid={form.errors.password && form.touched.password}>
                  <FormLabel color='text.600' htmlFor='password'>
                    New Password
                  </FormLabel>
                  <Input {...field} id='password' placeholder='Password' type='password' />
                  <FormErrorMessage>{form.errors.password}</FormErrorMessage>
                </FormControl>
              )}
            </Field>

            <Field name='passwordConfirm'>
              {/* // TODO: edit ts to not complain about this
               @ts-ignore */}
              {({ field, form }) => (
                <FormControl mb='8' isInvalid={form.errors.passwordConfirm && form.touched.passwordConfirm}>
                  <FormLabel color='text.600' htmlFor='passwordConfirm'>
                    Confirm Password
                  </FormLabel>
                  <Input {...field} id='passwordConfirm' placeholder='Confirm password' type='password' />
                  <FormErrorMessage>{form.errors.passwordConfirm}</FormErrorMessage>
                </FormControl>
              )}
            </Field>

            <Button
              size='lg'
              type='submit'
              mt='8'
              w='full'
              colorScheme='brand'
              fontSize='md'
              fontWeight='bold'
              isLoading={isSubmitting}
              isDisabled={!!errors.password}
            >
              Change password
            </Button>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default NewPasswordForm;
